import React, { useState } from "react";
import { Headers } from "../Header";
import { Footers } from "../Footer";
import { Outlet } from "react-router-dom";
import EventHeader from "../Header/EventHeader";

export const Main = ({ color, scrollItem, headerRef, setScrollItem }) => {
  const [showEvent, setShowEvent] = useState(true);
  const onClose = () => {
    setShowEvent(false);
  };
  return (
    <>
      <Headers headerRef={headerRef} color={color} scrollItem={scrollItem} />
      {/* {showEvent && (
        <EventHeader onClose={onClose} setScrollItem={setScrollItem} />
      )} */}
      <Outlet />
      <Footers />
    </>
  );
};
